export enum AssignmentDemandRole {
    AbsenceAssigmentRole = 'Absence',
    SuggestionsAssignmentRole = 'Suggested Assignments'
}
